const colors = new Set([
  'black', 'white', 'navy', 'navy blue', 'blue', 'light blue', 'dark blue',
  'grey', 'gray', 'charcoal', 'green', 'olive', 'olive green', 'dark green',
  'red', 'burgundy', 'brown', 'dark brown', 'beige', 'cream', 'off-white',
  'pink', 'purple', 'orange', 'yellow', 'sand', 'caviar'
]);

function normalize(value) {
  return String(value ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
}

function parseTitle(title) {
  const match = normalize(title).match(/^(.+?)(?: in | [-–—] )([^–—]+)$/);
  if (!match || !colors.has(match[2])) return null;
  return { model: match[1], color: match[2].replace(/^gray$/, 'grey') };
}

class ExactProductColors extends HTMLElement {
  async connectedCallback() {
    const current = parseTitle(this.dataset.title);
    const vendor = normalize(this.dataset.vendor);
    const list = this.querySelector('.ls-color-list');
    if (!current || !vendor || !list || this.loaded) return;
    this.loaded = true;

    try {
      const endpoint = new URL(this.dataset.search, location.origin);
      endpoint.searchParams.set('q', current.model);
      endpoint.searchParams.set('resources[type]', 'product');
      endpoint.searchParams.set('resources[limit]', '10');
      endpoint.searchParams.set('resources[options][unavailable_products]', 'show');
      const response = await fetch(endpoint);
      if (!response.ok || !this.isConnected) return;
      const { resources } = await response.json();
      const links = document.createDocumentFragment();
      const used = new Set([current.color]);

      for (const product of resources?.results?.products ?? []) {
        if (product.handle === this.dataset.handle || normalize(product.vendor) !== vendor) continue;
        const candidate = parseTitle(product.title);
        if (!candidate || candidate.model !== current.model) continue;
        if (used.has(candidate.color)) return;
        used.add(candidate.color);
        if (!product.url || !product.image) continue;

        const url = new URL(product.url, location.origin);
        const imageUrl = new URL(product.image, location.origin);
        if (url.origin !== location.origin || imageUrl.protocol !== 'https:') continue;
        imageUrl.searchParams.set('width', '180');
        const link = document.createElement('a');
        link.className = 'ls-color-card';
        link.href = url.href;
        link.title = product.title;
        link.setAttribute('aria-label', product.title);
        const image = document.createElement('img');
        image.alt = product.title;
        image.loading = 'lazy';
        image.src = imageUrl.href;
        link.append(image);
        links.append(link);
      }

      if (links.childElementCount && this.isConnected) {
        list.append(links);
        this.style.display = 'block';
        this.hidden = false;
      }
    } catch {
      // Keep the selector hidden when the catalogue search is unavailable.
    }
  }
}

if (!customElements.get('ls-exact-colors')) {
  customElements.define('ls-exact-colors', ExactProductColors);
}
